import Tabs from "@/components/Tabs";
import { Path } from "@/router";
import { useParams } from "react-router-dom";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const { pgaId } = useParams();

  if (!pgaId) return null;

  const tabItems = [
    {
      label: "Interactions",
      link: `/people/${pgaId}/interactions/interactions` as Path
    },
    {
      label: "Person History",
      link: `/people/${pgaId}/interactions/person-history` as Path
    }
  ];

  return (
    <>
      <Tabs tabItems={tabItems} />
      <div className="flex flex-col" data-testid="tab-content">
        {children}
      </div>
    </>
  );
}
